import { Group, SimpleGrid, Stack, Text } from "@mantine/core";
import {
  IconClock,
  IconDeviceMobile,
  IconPlane,
  IconShield,
  IconUser,
} from "@tabler/icons-react";
import TripDrawerField from "./TripDrawerField";
import { formatAmount, formatPolicyDate, purchaseMethodLabel } from "../../utils/allPolicyHelpers";
import classes from "./TripPolicyDrawer.module.css";

const SectionTitle = ({ icon: Icon, label }) => (
  <Group gap={8} mb="sm">
    <Icon size={16} color="#6C94B4" />
    <Text size="xs" c="dimmed" tt="uppercase" fw={700}>
      {label}
    </Text>
  </Group>
);

const TripDrawerOverview = ({ trip }) => {
  if (!trip) return null;
  const discount = Number(trip.discount);
  const duration = trip.duration != null ? `${trip.duration} days` : "—";

  return (
    <Stack gap="lg">
      <div>
        <SectionTitle icon={IconPlane} label="Journey" />
        <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="md">
          <TripDrawerField label="From" value={trip.traveller_from_name} />
          <TripDrawerField label="To" value={trip.traveller_to_name} />
          <TripDrawerField label="Dest. City" value={trip.destination_city} />
          <TripDrawerField label="Start Date" value={formatPolicyDate(trip.coverage_start_date)} />
          <TripDrawerField label="End Date" value={formatPolicyDate(trip.coverage_end_date)} />
          <TripDrawerField label="Duration" value={duration} />
          <TripDrawerField label="Cover Type" value={trip.cover_type} highlight="#033F7C" />
          <TripDrawerField label="Purchase" value={purchaseMethodLabel(trip.purchase_method)} highlight="#033F7C" />
        </SimpleGrid>
      </div>

      <div>
        <SectionTitle icon={IconUser} label="Customer" />
        <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="md">
          <TripDrawerField label="Name" value={trip.user_name} />
          <TripDrawerField label="Email" value={trip.email} />
          <TripDrawerField label="Phone" value={trip.phone_number} />
          <TripDrawerField label="Pax Count" value={trip.no_of_pax} />
        </SimpleGrid>
      </div>

      <div>
        <SectionTitle icon={IconShield} label="Financial" />
        <Group gap="md" wrap="wrap">
          <div className={classes.finCard} style={{ background: "#ECFDF3" }}>
            <Text fw={700} c="green.7">{formatAmount(trip.currency, trip.total_amount)}</Text>
            <Text size="xs" c="dimmed">Total Amount</Text>
          </div>
          <div className={classes.finCard} style={{ background: "#FFF4E8" }}>
            <Text fw={700} c="orange.7">{trip.no_of_pax ?? "—"}</Text>
            <Text size="xs" c="dimmed">Pax</Text>
          </div>
          <div className={classes.finCard} style={{ background: "#FDF2F8" }}>
            <Text fw={700} c="grape.7">
              {Number.isFinite(discount) && discount > 0 ? discount : "—"}
            </Text>
            <Text size="xs" c="dimmed">Discount</Text>
          </div>
        </Group>
      </div>

      <div>
        <SectionTitle icon={IconDeviceMobile} label="Operator" />
        <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="md">
          <TripDrawerField label="Tour Operator" value={trip.tour_operator_name} />
          <TripDrawerField label="Phone" value={trip.operator_phone_number} />
        </SimpleGrid>
      </div>

      <div>
        <SectionTitle icon={IconClock} label="Timeline" />
        <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="md">
          <TripDrawerField label="Created By" value={trip.created_by_name} />
          <TripDrawerField label="Created On" value={formatPolicyDate(trip.created_on)} />
          <TripDrawerField label="Updated On" value={formatPolicyDate(trip.updated_on)} />
        </SimpleGrid>
      </div>
    </Stack>
  );
};

export default TripDrawerOverview;
